<template>
    <ul class="flex-col m-center list-blank registration">
        <li>
            <h1>Register</h1>
        </li>
        <li :class="(available.username ? '' : 'invalid') + ' validate'">
            <label>{{ LANG.register.form.username }}</label>
            <input class="input" v-model="username" @keyup="onFieldUpdate('username')" />
            <span v-if="!available.username" class="bold status">
                <MySvg :icon="'times'" :class="'red'" />
            </span>
        </li>
        <li :class="(available.email ? '' : 'invalid') + ' validate'">
            <label>{{ LANG.register.form.email }}</label>
            <input type="email" class="input" v-model="email" @keyup="onFieldUpdate('email')" />
            <span v-if="!available.email" class="bold status">
                <MySvg :icon="'times'" :class="'red'" />
            </span>
        </li>
        <li>
            <label>{{ LANG.register.form.firstname }}</label>
            <input class="input" v-model="firstname">
        </li>
        <li>
            <label>{{ LANG.register.form.lastname }}</label>
            <input class="input" v-model="lastname">
        </li>
        <li>
            <label>{{ LANG.register.form.language }}</label>
            <select class="input" v-model="language">
                <option value="de">{{ LANG.profile.languages.de }}</option>
                <option value="en">{{ LANG.profile.languages.en }}</option>
            </select>
        </li>
        <li class="d-flex agb">
            <input v-model="agb" type="checkbox" id="agb" />
            <label v-html="LANG.register.form.agb_checkbox" for="agb"></label>
        </li>
        <li>
            <button v-if="!loading" class="btn btn-primary no-border" @click="register">
                {{ LANG.register.form.submit }}
            </button>
            <div v-else class="loader loader-sm"></div>
        </li>
        <li class="mt-20">
            <a href="#signin" class="green" @click="$emit('stateChanged', 'signin')">
                Back to sign in
            </a>
        </li>
    </ul>
</template>
<script>

import LANG from "../../i18n/loader"
import API from "../../helper/Api"
import MySvg from "../Svg.vue"
import Toastr from "toastr2"

const toastr = new Toastr()

export default {
    emits: [
        'stateChanged',
    ],
    data: () => {
        return {
            LANG,
            loading: false,
            username: "",
            email: "",
            firstname: "",
            lastname: "",
            language: "en",
            agb: false,
            hasUsernameBeenModified: false,
            available: {
                username: true,
                email: true
            }
        }
    },
    components: {
        MySvg,
    },
    methods: {
        onFieldUpdate(field) {
            if (field === 'username')
                this.hasUsernameBeenModified = true

            if (field === 'email' && !this.hasUsernameBeenModified)
                this.username = this.email

            if (this.inputWaiter)
                clearTimeout(this.inputWaiter)

            this.inputWaiter = setTimeout(this.checkForValidity, 300)
        },
        checkForValidity() {
            API.post("auth", "isEmailAndUsernameValid", {
                data: {
                    email: this.email.trim(),
                    username: this.username.trim()
                },
                success: (used) => {
                    if (this.username != "")
                        this.available.username = !Boolean(used.username)
                    else
                        this.available.username = true

                    if (this.email != "")
                        this.available.email = !Boolean(used.email)
                    else
                        this.available.email = true
                }
            })
        },
        register() {
            this.loading = true
            API.post("auth", "register", {
                data: {
                    email: this.email.trim(),
                    username: this.username.trim(),
                    firstname: this.firstname.trim(),
                    lastname: this.lastname.trim(),
                    language: this.language,
                    agb: this.agb,
                },
                completed: () => {
                    this.loading = false
                },
                success: () => {
                    toastr.success(
                        LANG.register.success.text,
                        LANG.register.success.title
                    )

                    this.$emit('stateChanged', 'signin')
                }
            })
        }
    },
}
</script>